export const UPDATE_IMPORT_EXPORT_WIZARD_LOCK = 'UPDATE_IMPORT_EXPORT_WIZARD_LOCK';
export type UPDATE_IMPORT_EXPORT_WIZARD_LOCK = typeof UPDATE_IMPORT_EXPORT_WIZARD_LOCK;

export interface UpdateImportExportWizardLock {
    type: UPDATE_IMPORT_EXPORT_WIZARD_LOCK;
    isLocked: boolean;
}

export function updateImportExportWizardLockAction(isLocked: boolean): UpdateImportExportWizardLock {
    return {
        type: UPDATE_IMPORT_EXPORT_WIZARD_LOCK,
        isLocked
    };
}
